var index, toc;

toc = require("./toc-tree.js");

index = void 0;

module.exports = function() {
  var project, projects;
  if (index != null) {
    return index;
  }
  projects = {};
  project = toc.first("projects");
  while (project != null) {
    projects[project.nodeId] = project.title;
    project = toc.next("projects", project.id);
  }
  return index = projects;
};
